import VehicleType from '@/enums/VehicleType';
import PricingProviderType from '@/enums/valuation/PricingProviderType';

export default class ValuationRequest {
  public registration: string = '';

  public mileage: number = 0;

  public vehicleType: VehicleType = VehicleType.Car;

  public vehiclePricingProviderType: PricingProviderType = PricingProviderType.UkVehicleData;
}
